var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2800_14194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.667 181.667V115H148.333V148.333H115V265H181.667V231.667H198.333V265H265V181.667H231.667ZM148.333 248.333H131.667V231.667H148.333V248.333ZM148.333 215H131.667V198.333H148.333V215ZM148.333 181.667H131.667V165H148.333V181.667ZM181.667 215H165V198.333H181.667V215ZM181.667 181.667H165V165H181.667V181.667ZM181.667 148.333H165V131.667H181.667V148.333ZM215 215H198.333V198.333H215V215ZM215 181.667H198.333V165H215V181.667ZM215 148.333H198.333V131.667H215V148.333ZM248.333 248.333H231.667V231.667H248.333V248.333ZM248.333 215H231.667V198.333H248.333V215Z",
    fill: "#E9E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2800_14194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 380,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.a36c824009b05668e807b37c0dd8de1e.svg";
export { ForwardRef as ReactComponent };